'use strict'

import Input from "../../utils/Input";
import Scrollbar from 'smooth-scrollbar';

class JoinUs{
    constructor(){
        
        this.scrollVideo = document.getElementById('section_work_in_guyer');
        this.videoBtn = document.querySelector('#section_work_in_guyer .btn-play');
        this.video = document.querySelector('#section_work_in_guyer video');
        this.videoText = document.querySelector('#section_work_in_guyer .container h1');
        this.videoMore = document.querySelector('#section_work_in_guyer .scroll-down');
        this.main = document.getElementById('join_us_page');
        this.searchForm = document.getElementById('jobs_search_form');
        this.shouldAnimateHero = !!this.searchForm;


        this.join_us_video_btn = document.getElementById('join_us_video_btn');
        this.video_thumb = this.join_us_video_btn.querySelectorAll('.video__thumb')[0];
        this.join_us_video_btn.addEventListener('click', (e)=>{
            e.preventDefault();
            let source = this.video_thumb.getAttribute('data-source');
            let vid = App.modalVideo.show(source, 'video-url');
            vid.showControls().unMute();
        });

        this.videoBtn.addEventListener('click',(e) => {
            e.preventDefault();
            this.scrollVideo.classList.add('video-is-playing');
            this.video.controls = true;
            this.video.play();
            this.videoBtn.style.display = 'none';
            this.videoText.style.display = 'none';
            this.videoMore.style.display = 'none!important';
        });

        this.video.onstop = (e) => {
            this.video.controls = false;
            this.scrollVideo.classList.remove('video-is-playing');
            this.videoBtn.style.display = 'block';
            this.videoText.style.display = 'block';
            this.videoMore.style.display = 'block!important';
        };

        this.video.onended = (e) => {
            this.video.controls = false;
            this.scrollVideo.classList.remove('video-is-playing');
            this.videoBtn.style.display = 'block';
            this.videoText.style.display = 'block';
            this.videoMore.style.display = 'block!important';
            
        };

        if(this.scrollVideo.classList.contains('section-in-mobile')){
            this.videoBtn.className = "btn-play btn-play--show";
            return;
        }

        this.videoMore.addEventListener('click',(e) => {
            e.preventDefault();
            let target = this.shouldAnimateHero ? this._getHeroAnimationLimit() : this.main.querySelector('.section--why-work').offsetTop;
            JoinUs.scrollbar.scrollTo(0, target, 1000);
        });

        if(this.searchForm){
            this._inputTerm = new Input(this.searchForm.querySelector('input[name="term"]'));

            this._searchBtn = this.main.querySelector('.icon-search');
            this._searchBtn.addEventListener('click', this._onClickSearchByTerm.bind(this));

            this.searchForm.querySelector('input[name="term"]').addEventListener('keydown', (e) => {
                if(e.keyCode == 13 || e.keyCode == 27){
                    e.preventDefault();
                    this._searchBtn.click();
                    return false;
                }
                return true;
            });

            //data-category

            this.lawersCategory = this.main.querySelector('.all-category');
            this.lawersCategory.addEventListener('click', this._onClickSearchByCategory.bind(this));

            this.lawersCategory = this.main.querySelector('.lawyers-category');
            this.lawersCategory.addEventListener('click', this._onClickSearchByCategory.bind(this));

            this.notariesCategory = this.main.querySelector('.notaries-category');
            this.notariesCategory.addEventListener('click', this._onClickSearchByCategory.bind(this));

            this.accountantsCategory = this.main.querySelector('.accountants-category');
            this.accountantsCategory.addEventListener('click', this._onClickSearchByCategory.bind(this));

            this.othersCategory = this.main.querySelector('.others-category');
            this.othersCategory.addEventListener('click', this._onClickSearchByCategory.bind(this));

            this.main.querySelectorAll('.job-item').forEach(element => {
                element.addEventListener('click', this._onClickJobItem.bind(this));
            });

            this.main.querySelectorAll('.card__title').forEach(element => {
                element.addEventListener('click', this._onClickJobItemChildren.bind(this));
            });

            this.main.querySelectorAll('.card__description').forEach(element => {
                element.addEventListener('click', this._onClickJobItemChildren.bind(this));
            });

            this.main.querySelectorAll('.card__link').forEach(element => {
                element.addEventListener('click', this._onClickJobItemChildren.bind(this));
            });

            var that = this;

            document.addEventListener('click',function(e){
                if(e.target && e.target.classList.contains('job-item')){
                    that._onClickJobItem(e);
                }
            });
        }

         JoinUs.scrollbar = Scrollbar.init(document.querySelector('.page'), {
            alwaysShowTracks: false,
         });

         JoinUs.scrollbar.addListener(this._onScrollbarEvent.bind(this));
    }

    _getHeroAnimationLimit(){
        return this.scrollVideo.offsetHeight;
    }

    _getHeroAnimationTop(scrollTop){
        return (scrollTop * 300) / 722;
    }

    _onScrollbarEvent(e){
        let __scroll_y = JoinUs.scrollbar.scrollTop;
        let top = this._getHeroAnimationLimit();
        let __scroll = (__scroll_y - top) * -1;

        if(__scroll <= 0) {
            if(!this.shouldAnimateHero){
                let y = this._getHeroAnimationTop(top);

                this.videoBtn.className = "btn-play btn-play--show";
                this.videoText.style.opacity = 0;
                this.videoText.style.transform = `translate3d(0, ${-__scroll_y}px, 0)`;
                this.videoMore.style.opacity = 0;
                this.scrollVideo.style.transform = `matrix(0.5, 0, 0, 0.5, 0, 0) translate3d(0, ${top}px, 0)`;
                this.scrollVideo.style.top = `${y}px`;
            }
            return;
        }
        let wh = ((__scroll * 0.5) / top) + 0.5;
        let op = (__scroll - (top * 322 / 722)) / (top * 400 / 722);
        let y = this._getHeroAnimationTop(__scroll_y);
        
        if(op <= 0) {
            this.videoBtn.className = "btn-play btn-play--show";
        } else {
            this.videoBtn.className = "btn-play";
        }
        this.videoText.style.opacity = op;
        this.videoText.style.transform = `translate3d(0, ${-__scroll_y}px, 0)`;
        this.videoMore.style.opacity = op;
        //this.videoText.style.top = `${__scroll_y - ts}px`;

        this.scrollVideo.style.transform = `matrix(${wh}, 0, 0, ${wh}, 0, 0) translate3d(0, ${__scroll_y}px, 0)`;
        this.scrollVideo.style.top = `${y}px`;
        
    }

    _onClickJobItemChildren(e){
        e.preventDefault();
        e.stopPropagation();

        let jobId = e.target.parentElement.parentElement.dataset.id;
        this.goToJobItem(jobId);
    }

    _onClickJobItem(e){
        e.preventDefault();

        let jobId = e.target.dataset.id;
        this.goToJobItem(jobId);
    }

    goToJobItem(jobId) {
        var lang = this.main.getAttribute('data-page-lang');

        if (lang == 'es') {
            window.location.href = App.baseUrl + 'trabaja-con-nosotros/ofertas/' + jobId;
        } else {
            window.location.href = App.baseUrl + 'join-us/jobs/' + jobId;
        }
    }

    _onClickSearchByTerm(e){
        e.preventDefault();

        let requestData = {
            category: '',
            term: this._inputTerm.value,
            lang: this.main.getAttribute('data-page-lang')
        };

        fetch(App.baseUrl + 'join-us/jobs/search', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache'
            },
            body: JSON.stringify(requestData)
        })
        .then((response) => {
            return response.json();
        }).then((res) => {
            document.getElementById('jobs').innerHTML = res.data;
        });
    }

    _onClickSearchByCategory (e){
        e.preventDefault();

        let requestData = {
            category: e.target.dataset.category,
            term: this._inputTerm.value,
            lang: this.main.getAttribute('data-page-lang')
        };

        fetch(App.baseUrl + 'join-us/jobs/search', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache'
            },
            body: JSON.stringify(requestData)
        })
        .then((response) => {
            return response.json();
        }).then((res) => {
            document.getElementById('jobs').innerHTML = res.data;
        });
    }
}

export default JoinUs;
